import { Pipe, PipeTransform } from '@angular/core';
import { NS_Enums } from '../../namespaces';
import { includes as _includes} from 'lodash-es';
import { environment } from 'src/environments/environment';
import { hasAdminAccess, hasCStudioAccess } from '../../helpers/helpers';
@Pipe({
  name: 'enableFeature'
})
export class EnableFeaturePipe implements PipeTransform {
  constructor() {}
  transform(object: any, feature: any): boolean {
    const {userId, userRole, hasUserDashboardAccess = false} = object;
    switch (feature) {
      case ('admin'):
        return hasAdminAccess(userRole)
      case ('cstudio'):
        return hasCStudioAccess(userRole);
      case NS_Enums.routePathEnum.dashboards:
        return hasUserDashboardAccess;
      default:
        break;
    }
    return null;
  }

}
